import type { DatasetObservation } from '../ml/datasetObservations';
import './DatasetObservations.css';

export interface DatasetObservationsProps {
  observations: DatasetObservation[];
}

/**
 * Gentle, kid-facing observations about the dataset. Phrased as invitations,
 * never as warnings or errors — the kid is making something, not failing a
 * test. Renders nothing when there's nothing to say.
 */
export function DatasetObservations({
  observations,
}: DatasetObservationsProps): JSX.Element | null {
  if (observations.length === 0) return null;
  return (
    <aside className="bl-obs" aria-label="Suggestions for your dataset">
      <p className="bl-obs__title">A few things you could try</p>
      <ul className="bl-obs__list">
        {observations.map((obs, i) => (
          <li key={`${obs.kind}-${obs.classId ?? 'project'}-${i}`} className="bl-obs__item">
            {obs.message}
          </li>
        ))}
      </ul>
    </aside>
  );
}
